import {getNextDay} from "./util";

export function findReplaceArticleStep(item) {
  if (item && item.extras && item.extras.variants) {
    for (let step of item.extras.variants) {
      if (step.replaceArticle) {
        return step;
      }
    }
  }

  return null;
}

export function itemsContainsTicket(items) {
  try {
    for (let item of items) {
      if (!!item.ticket) {
        return true;
      }
    }
  } catch (e) {

  }
  return false;
}
